export enum ReportType {
  JOBS_REPORT = 'jobs-report',
  MESSAGE_DOWNLOAD = 'message-download',
  QUESTION_RESPONSES = 'question-responses',
  TRACKED_LINK_CLICKS = 'tracked-link-clicks',
  AI_SUPPORT = 'ai-support',
}

export type ReportContext = 'job-list' | 'job-details';

export interface ReportFormValues {
  startDate: string;
  endDate: string;
  createSuppressionList?: boolean;
  suppressionListName?: string;
  createPhoneList?: boolean;
  phoneListName?: string;
}

export interface ReportConfig {
  label: string;
  type: ReportType;
  description?: string;
}

export interface ReportFormProps {
  values: ReportFormValues;
  onChange: (
    field: keyof ReportFormValues,
    value: ReportFormValues[keyof ReportFormValues]
  ) => void;
  errors?: Record<string, string>;
  isGenerating?: boolean;
  accountId?: string;
  jobId?: string;
  availableReports: ReportType[];
  selectedReportType: ReportType | null;
  onReportTypeChange: (type: ReportType) => void;
}

// API Payload Types
export interface BaseReportPayload {
  account_id?: string;
  date_range: 'CUSTOM';
  start_date: string; // YYYY-MM-DD
  end_date: string; // YYYY-MM-DD
  justsurveys: boolean;
  justlastpass: boolean;
  show_headers: boolean;
  reportformat: 'csv';
}

export interface JobDetailsReportPayload extends BaseReportPayload {
  create_suppression_list: boolean;
  create_phone_list: boolean;
  suppression_list_name?: string;
  phone_list_name?: string;
}

export interface ReportResponse {
  result: string;
  link: string;
}
